import React from "react"
import DfbImage from "../ui-kit/dfb_image"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbRte from "../ui-kit/dfb_rte"
import CModalBase from "./c_modal_base"
import CMediaVideo from "./c_media_video"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import { Transformation } from "cloudinary-react"

/**
 * Will render a speaker teaser card that opens a popup with details on click.
 * @param props.description_tile The subline below the image title in the dialog
 * @param props.description_modal_first_line The subline below the teaser image title
 * @param props.description_modal_second_line An additional subline below the teaser image title
 * @param props.image_modal The image that is shown in the dialog (title image will be used if not specified)
 * @param props.image_tile The image used in the teaser card
 * @param props.name_modal The name / title shown below the image in the dialog (title name is used if empty)
 * @param props.name_tile The name / title shown below the teaser image
 * @param props.text_modal The rich text content shown in the dialog
 */
const CSpeaker = (props) => {
  const modalImage =
    props.image_modal && props.image_modal.src
      ? props.image_modal
      : props.image_tile
  const modalTitle = props.name_modal || props.name_tile
  const modalVideoId = props.video_embed_code_modal || null
  const id = `speaker-${props.id}`

  let tileImageTitle = props.name_tile;
  if(props.image_tile.title) {
    tileImageTitle += " / " + props.image_tile.title
  }
  let modalImageTitle = props.name_modal || props.name_tile
  if(props.image_modal.title) {
    modalImageTitle += " / " + props.image_modal.title 
  }
        
  return (
    <div className="c-Speaker">
      <a
        href={`#${id}`}
        className="c-Speaker-card"
        data-toggle="modal"
        data-target={id}
      >
        <div className="c-Speaker-imageContainer" title={props.name_tile}>
          {props.image_tile && props.image_tile.src && (
            <DfbImage
              add_class="c-Speaker-image"
              image={{
                src: props.image_tile.src,
                alternative: props.name_tile,
                title: tileImageTitle,
              }}
              overlay="55"
              lazyload
              aspect_ratio="4:3"
            >
              <Transformation
                crop="fill"
                gravity="faces:center"
                width="800"
                height="600"
                quality="auto"
                fetchFormat="auto"
              />
            </DfbImage>
          )}
        </div>
        <div className="c-Speaker-meta">
          <DfbHeadline
            headline={props.name_tile}
            headline_level="h6"
            add_class="c-Speaker-name"
          />
          <DfbParagraph
            text={props.description_tile}
            add_class="dfb-Paragraph--small c-Speaker-position"
          />
        </div>
        <DfbIcon icon_type="add" add_class="c-Speaker-more" />
      </a>
      <CModalBase id={id} add_class="dfb-Modal--fullsizePhone c-Speaker-modal">
        <div className="c-Speaker-dialogContainer">
          <div className="c-Speaker-dialogMeta">
            <div className="c-Speaker-dialogImageContainer" title={modalTitle}>
              {modalVideoId && <CMediaVideo video_embed_id={modalVideoId} />}
              {!modalVideoId && modalImage && modalImage.src && (
                <DfbImage
                  add_class="c-Speaker-dialogImage"
                  image={{
                    src: modalImage.src,
                    alternative: modalTitle,
                    title: modalImageTitle,
                  }}
                  overlay="55"
                  lazyload
                  aspect_ratio="4:3"
                >
                  <Transformation
                    crop="fill"
                    gravity="faces:center"
                    width="800"
                    height="600"
                    quality="auto"
                    fetchFormat="auto"
                  />
                </DfbImage>
              )}
            </div>
            <DfbHeadline
              headline={modalTitle}
              headline_level="h4"
              add_class="c-Speaker-dialogName"
            />
            <p className="dfb-Paragraph dfb-Paragraph--small c-Speaker-dialogPosition">
              {props.description_modal_first_line}
              {props.description_modal_first_line &&
                props.description_modal_second_line && <br />}
              {props.description_modal_second_line}
            </p>
            <hr className="dfb-Divider c-Speaker-dialogDivider" />
          </div>
          <div className="c-Speaker-dialogInformation">
            <div className="c-Speaker-dialogDescription">
              {props.text_modal && (
                <DfbRte
                  text={props.text_modal}
                  add_class="c-Speaker-dialogRte"
                />
              )}
            </div>
          </div>
        </div>
      </CModalBase>
    </div>
  )
}

export default CSpeaker
